type Props = {
  phoneNumber?: string;
};

const defaultData: Props = {
  phoneNumber: "",
};

export class RechargeNumberModel {
  phoneNumber?: string;

  constructor(data: Props = defaultData) {
    this.phoneNumber = data.phoneNumber || "";
  }
}
